module.exports = __webpack_public_path__ + "static/img/chejia_6.e189fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_6.png
// module id = o4bb
// module chunks = 19